import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Core from '../components/core-view';
import {
  isUserInvitationPage,
  isInvitationAcceptancePage,
} from 'lib/utility-functions';
import {
  uiAlertAuthenticationWarningVisible,
  uiAlertAuthenticationExpiredVisible,
  uiToastrMessage,
  uiConfirmDialog,
  uiMessageBannerVisible,
  uiShowMessageBanner,
} from 'modules/ui-module';
import { meIsConflicted } from 'modules/me-module';
import Session from "lib/session";
import config from "config/appconfig";
import auth from "lib/profile-auth";

export class CoreContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  handleReload = () => {
    Session.removeItem(config.storage.oauth);
    return window.location.reload();
  }

  handleSignOut = () => {
    this.props.logout();
  }

  componentDidMount() {
    if(this.props.isUserConflicted) {
      this.props.uiShowMessageBanner('userIsConflicted', {onclick: this.handleSignOut});
    }
  }

  render() {
    return (
      <Core
        alertAuthWarningIsVisible={this.props.alertAuthWarningIsVisible}
        alertAuthExpiredIsVisible={this.props.alertAuthExpiredIsVisible}
        messageBannerVisible={this.props.messageBannerVisible}
        toastrMessage={this.props.toastrMessage}
        confirmDialog={this.props.confirmDialog}
        useStandardNav={!(isUserInvitationPage() || isInvitationAcceptancePage())}
      />
    );
  }
}

CoreContainer.propTypes = {
  alertAuthWarningIsVisible: PropTypes.bool,
  alertAuthExpiredIsVisible: PropTypes.bool,
  messageBannerVisible: PropTypes.bool,
  toastrMessage: PropTypes.shape({
    type: PropTypes.string,
    messageId: PropTypes.string,
    params: PropTypes.object,
  }),
  confirmDialog: PropTypes.shape({
    textResourceId: PropTypes.string,
    yesCallbackFn: PropTypes.func,
    noCallbackFn: PropTypes.func,
  }),
  isUserConflicted: PropTypes.bool,
  uiShowMessageBanner: PropTypes.func,
  logout: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => ({
  alertAuthWarningIsVisible: uiAlertAuthenticationWarningVisible(state),
  alertAuthExpiredIsVisible: uiAlertAuthenticationExpiredVisible(state),
  messageBannerVisible: uiMessageBannerVisible(state),
  toastrMessage: uiToastrMessage(state),
  confirmDialog: uiConfirmDialog(state),
  isUserConflicted: meIsConflicted(state),
  logout: auth.logout.bind(auth),
});

export const mapDispatchToProps = (dispatch) => ({
  uiShowMessageBanner: (messageId, params = {}) => dispatch(uiShowMessageBanner(messageId, params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CoreContainer);
